export default __webpack_public_path__ + "/dist/images/box-icon.9bfc0bf4e65655167e3bfa9a66ec4e38.svg";